/**
 * Remove all empty (null, undefined, empty string) properties from an object (recursively, including nested objects).
 * Needed to send data that can be parsed by the backend.
 * @param obj The object to filter.
 */
const removeEmptyProperties = (obj) => {
  Object.keys(obj).forEach((key) => {
    if (obj[key] && typeof obj[key] === 'object') {
      removeEmptyProperties(obj[key]); // recurse
    } else if ((obj[key] == null || obj[key] === '') && key !== 'validTo') {
      Reflect.deleteProperty(obj, key);
    }
  });
};

export const deepCopy = (inObject) => {
  let value, key;

  if (typeof inObject !== 'object' || inObject === null || inObject instanceof Date) {
    return inObject; // Return the value if inObject is not an object.
  }

  // Create an array or object to hold the values
  const outObject = Array.isArray(inObject) ? [] : {};

  for (key in inObject) {
    value = inObject[key];

    // Recursively (deep) copy for nested objects, including arrays
    outObject[key] = deepCopy(value);
  }

  return outObject;
};

export default removeEmptyProperties;
